/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsDocuments } from './HchbPatientDetailsDocuments';
import {
    HchbPatientDetailsDocumentsFromJSON,
    HchbPatientDetailsDocumentsFromJSONTyped,
    HchbPatientDetailsDocumentsToJSON,
    HchbPatientDetailsDocumentsToJSONTyped,
} from './HchbPatientDetailsDocuments';
import type { HchbPatientDetailsExternalEhrPatient } from './HchbPatientDetailsExternalEhrPatient';
import {
    HchbPatientDetailsExternalEhrPatientFromJSON,
    HchbPatientDetailsExternalEhrPatientFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientToJSON,
    HchbPatientDetailsExternalEhrPatientToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatient';

/**
 * 
 * @export
 * @interface HchbPatientDetails
 */
export interface HchbPatientDetails {
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatient}
     * @memberof HchbPatientDetails
     */
    external_ehr_patient?: HchbPatientDetailsExternalEhrPatient;
    /**
     * 
     * @type {HchbPatientDetailsDocuments}
     * @memberof HchbPatientDetails
     */
    documents?: HchbPatientDetailsDocuments;
}

/**
 * Check if a given object implements the HchbPatientDetails interface.
 */
export function instanceOfHchbPatientDetails(value: object): value is HchbPatientDetails {
    return true;
}

export function HchbPatientDetailsFromJSON(json: any): HchbPatientDetails {
    return HchbPatientDetailsFromJSONTyped(json, false);
}

export function HchbPatientDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : HchbPatientDetailsExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'documents': json['documents'] == null ? undefined : HchbPatientDetailsDocumentsFromJSON(json['documents']),
    };
}

export function HchbPatientDetailsToJSON(json: any): HchbPatientDetails {
    return HchbPatientDetailsToJSONTyped(json, false);
}

export function HchbPatientDetailsToJSONTyped(value?: HchbPatientDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'external_ehr_patient': HchbPatientDetailsExternalEhrPatientToJSON(value['external_ehr_patient']),
        'documents': HchbPatientDetailsDocumentsToJSON(value['documents']),
    };
}

